import { Button, Col, Form, Row, Select, Space, Upload } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showSuccess, useLayoutBreaks } from "helpers/utility";
import useAjax from "helpers/ajax";
import CSelect from "components/CSelect";
import { useEffect, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

const ImportDevice = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const breaks = useLayoutBreaks();
  const { post, get } = useAjax();
  const edit = state ? true : false;
  const [distributors, setDistributors] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [errors, setErrors] = useState([]);

  const onFinish = ({ companyID }) => {
    const data = new FormData();
    data.set("companyID", companyID);
    fileList.forEach((file) => {
      data.append("file", file);
    });
    post("api/v1/devices/import", data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((resp) => {
        if (resp.success) {
          showSuccess(resp.message).then(() => {
            navigate("/devices/devices");
          });
        } else {
          setErrors(resp.data);
        }
      })
      .catch((err) => {
        showError(err);
      });
  };

  const onDownloadTemplate = () => {
    get("api/v1/devices/downloadtemplate", {}, { responseType: "blob" })
      .then((resp) => {
        const url = window.URL.createObjectURL(new Blob([resp]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        showError(err);
      });
  };

  const uploadProps = {
    multiple: false,
    //showUploadList: false,
    accept:
      ".xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    beforeUpload: (file) => {
      var fileExt = file.name.split(".").pop();
      const validList = ["xls", "xlsx"];
      const isValid = validList.indexOf(fileExt) > -1;
      if (!isValid) {
        showError(`${file.name} is not an excel file`);
      } else {
        setFileList([...fileList, file]);
      }
      return false;
    },
    fileList,
  };

  useEffect(() => {
    get("api/v1/lookups/distributors")
      .then((resp) => {
        setDistributors(resp);
      })
      .catch((err) => {
        showError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      layout="vertical"
      initialValues={{
        ...state,
        active: !edit ? true : state.active,
        compatible: !edit ? true : state.compatible,
      }}
      onFinish={onFinish}
    >
      <Row gutter={24}>
        <Col {...breaks}>
          <Form.Item
            label="Distributor name"
            name="companyID"
            // rules={[{ required: true }]}
          >
            <CSelect allowClear={true}>
              {distributors.map((r) => (
                <Select.Option key={r.value} value={r.value}>
                  {r.text}
                </Select.Option>
              ))}
            </CSelect>
          </Form.Item>
          <Form.Item
            name="file"
            label="Data file (*.xlsx)"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[{ required: true }]}
          >
            <Upload.Dragger name="file" {...uploadProps}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                Support for a single *.xlsx file upload.
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  navigate("/devices/devices");
                }}
              >
                Cancel
              </Button>
              <Button
                htmlType="button"
                type="link"
                onClick={onDownloadTemplate}
              >
                Download sample
              </Button>
            </Space>
          </Form.Item>
        </Col>
        {errors.length > 0 && (
          <Col {...breaks}>
            <div style={{ color: "red" }}>
              <h4 style={{ color: "red" }}>
                Following serial no(s) already exist:
              </h4>
              <ul>
                {errors.map((error) => (
                  <li key={error}>{error}</li>
                ))}
              </ul>
            </div>
          </Col>
        )}
      </Row>
    </Form>
  );
};
export default ImportDevice;
